import { Timestamp } from "firebase/firestore";

export function crossDateValidator(type: "before" | "after", comparedTo: string) {
  return (value: any, values: Record<string, any>, entry: any) => {
    let isValid = true;

    if (type === "after") {
      isValid =
        (value instanceof Timestamp ? value.toMillis() : new Date(value).valueOf()) >
        (values[comparedTo] instanceof Timestamp
          ? values[comparedTo].toMillis()
          : new Date(values[comparedTo]).valueOf());
    }

    if (type === "before") {
      isValid =
        (value instanceof Timestamp ? value.toMillis() : new Date(value).valueOf()) <
        (values[comparedTo] instanceof Timestamp
          ? values[comparedTo].toMillis()
          : new Date(values[comparedTo]).valueOf());
    }

    return isValid
      ? undefined
      : type === "after"
      ? `Date '${entry.name}' should be greater than '${comparedTo}'`
      : `Date '${entry.name}' should be less than '${comparedTo}'`;
  };
}
